import { Record } from "immutable";
import {
    onSettingsLoadSuccess,
    onSettingsSave,
    onSettingsSaveFail,
    onSettingsSaveSuccess,
    onSettingsSetLogo,
    onSettingsSetSplash,
    COMPANY_DETAILS_SAVE,
    COMPANY_DETAILS_SAVE_SUCCESS,
    COMPANY_DETAILS_SAVE_FAIL,
    TAX_NEW_CREATE,
    TAX_NEW_CREATE_FAIL,
    TAX_NEW_CREATE_SUCCESS,
    PASSWORD_UPDATE,
    PASSWORD_UPDATE_SUCCESS,
    PASSWORD_UPDATE_FAIL,
    CHANGE_DEFAULT_PAYMENT_SYSTEM_SAVE,
    CHANGE_DEFAULT_PAYMENT_SYSTEM_SAVE_SUCCESS,
    CHANGE_DEFAULT_PAYMENT_SYSTEM_SAVE_FAIL,
    LOGOUT_SESSIONS,
    LOGOUT_SESSIONS_SUCCESS,
    LOGOUT_SESSIONS_FAIL,
    COMPANY_SETTING_LOAD,
    COMPANY_SETTING_LOAD_FAIL,
    COMPANY_SETTING_LOAD_SUCCESS,
    COMPANY_SETTING_LISTS_LOAD,
    COMPANY_SETTING_LISTS_LOAD_SUCCESS,
    COMPANY_SETTING_LISTS_LOAD_FAIL,
    COMPANY_SETTINGS_SAVE,
    COMPANY_SETTINGS_SAVE_SUCCESS,
    COMPANY_SETTINGS_SAVE_FAIL,
    ALL_TAX_LOAD,
    ALL_TAX_LOAD_SUCCESS,
    ALL_TAX_LOAD_FAIL,
    TAX_LOAD,
    TAX_LOAD_SUCCESS,
    TAX_LOAD_FAIL,
    TAX_DELETE,
    TAX_DELETE_SUCCESS,
    TAX_DELETE_FAIL,
    ALL_RESTORANTS_LOAD,
    ALL_RESTORANTS_LOAD_SUCCESS,
    ALL_RESTORANTS_LOAD_FAIL,
    TAX_FIELD_CLEAR,
    USER_PROFILE_UPDATE,
    USER_PROFILE_UPDATE_SUCCESS,
    USER_PROFILE_UPDATE_FAIL,
    USER_PROFILE_LOAD,
    USER_PROFILE_LOAD_SUCCESS,
    USER_PROFILE_LOAD_FAIL,
    DEFAULT_PAYMENT_LOAD,
    DEFAULT_PAYMENT_LOAD_SUCCESS,
    DEFAULT_PAYMENT_LOAD_FAIL,
    STRIPE_SYSTEM_DEAUTHORIZE,
    STRIPE_SYSTEM_DEAUTHORIZE_SUCCESS,
    STRIPE_SYSTEM_DEAUTHORIZE_FAIL,
    YOOKASA_SYSTEM_DEAUTHORIZE,
    YOOKASA_SYSTEM_DEAUTHORIZE_SUCCESS,
    YOOKASA_SYSTEM_DEAUTHORIZE_FAIL,
    AMERIABANK_ACCOUNT_SAVE,
    AMERIABANK_ACCOUNT_SAVE_SUCCESS,
    AMERIABANK_ACCOUNT_SAVE_FAIL,
    AMERIABANK_ACCOUNT_DELETE,
    AMERIABANK_ACCOUNT_DELETE_SUCCESS,
    AMERIABANK_ACCOUNT_DELETE_FAIL,
    TWO_FACTOR_AUTH_CONFIRM_PASSWORD,
    TWO_FACTOR_AUTH_CONFIRM_PASSWORD_SUCCESS,
    TWO_FACTOR_AUTH_CONFIRM_PASSWORD_FAIL,
    REGENERATE_CODE,
    REGENERATE_CODE_SUCCESS,
    REGENERATE_CODE_FAIL,
    DELETE_ACCOUNT,
    DELETE_ACCOUNT_SUCCESS,
    DELETE_ACCOUNT_FAIL,
} from "./actions";

const settings = new Record({
    logo: null,
    splash: null,
    loading: false,
    redirect:false,
    company_details: {
        company_name: "",
        company_email: "",
        company_phone: "",
        cheqit_domain: "",
        company_registered_name: "",
        company_accounts_email: "",
        company_reg_number: "",
        company_vat_id: "",
        company_registered_adress: "",
    },
    company_preferences: {
        country: [],
        currency: [],
        timezone: [],
        language: [],
        privacy_policy: "",
        terms_conditions: "",
        contacts_text: "",
    },
    company_setting_lists:{
        countries_list: [],
        currencies_list: [],
        timezones_list: [],
        languages_list:[],
    },
    tax_list:[],
    tax:{
        name: "",
        rate: "",
        is_included: false,
        is_enable:false,
        all_future_locations: false,
        is_all_restaurants: false,
        restaurants:[]
    },
    all_restaurants_list:[],
    payments:{
        paymentProviders: {},
        defaultProvider: "",
        stripeAccounts: [],
        stripeOauthLink:"",
        yookassaAccounts: [],
        yookassaOauthLink: "",
        ameriabankAccount : {}
    },
    user_profile:{
        name: "",
        email: "",
        browser_sessions_list: [],
        two_factor_authentication: [],
        is_two_factor_enabled: false
    },

})();

export default (state = settings, action) => {
    switch (action.type) {
        case onSettingsSetLogo().type:
            return state.set("logo", action.value);
        case onSettingsSetSplash().type:
            return state.set("splash", action.value);

        case onSettingsSave().type:
            return state.set("loading", true);

        case onSettingsSaveSuccess().type:
        case onSettingsSaveFail().type:
            return state.set("loading", false);

        case onSettingsLoadSuccess().type:
            return state
                .set("logo", action.response.logo)
                .set("splash", action.response.splash);


        // CompanySettings load

        case COMPANY_SETTING_LOAD:
            return state.set("loading", true);

        case COMPANY_SETTING_LOAD_SUCCESS:
            return state
                .set("loading", false)
                .setIn(["company_details", "company_name"], action.response.contact_details.company_name)
                .setIn(["company_details", "company_email"], action.response.contact_details.email)
                .setIn(["company_details", "company_phone"], action.response.contact_details.phone)
                .setIn(["company_details", "contacts_text"], action.response.contact_details.text)
                .setIn(["company_details", "cheqit_domain"], action.response.domain)
                .setIn(["company_details", "company_registered_name"], action.response.legal_details.company_name)
                .setIn(["company_details", "company_accounts_email"], action.response.legal_details.email)
                .setIn(["company_details", "company_reg_number"], action.response.legal_details.registration_number)
                .setIn(["company_details", "company_vat_id"], action.response.legal_details.vat_id)
                .setIn(["company_details", "company_registered_adress"], action.response.legal_details.address)
                .setIn(["company_preferences", "country"], action.response.country)
                .setIn(["company_preferences", "currency"], action.response.currency)
                .setIn(["company_preferences", "timezone"], action.response.timezone)
                .setIn(["company_preferences", "language"], action.response.language)
                .setIn(["company_preferences", "privacy_policy"], action.response.privacy_link)
                .setIn(["company_preferences", "terms_conditions"], action.response.terms_link)

        case COMPANY_SETTING_LOAD_FAIL:
            return state.set("loading", false);

        // CompanySettingsLists load

        case COMPANY_SETTING_LISTS_LOAD:
            return state.set("loading", true);

        case COMPANY_SETTING_LISTS_LOAD_SUCCESS:
            return state
                .set("loading", false)
                .setIn(["company_setting_lists", "countries_list"], action.response.countries)
                .setIn(["company_setting_lists", "currencies_list"], action.response.currencies)
                .setIn(["company_setting_lists", "timezones_list"], action.response.timezones)
                .setIn(["company_setting_lists", "languages_list"], action.response.languages)

        case COMPANY_SETTING_LISTS_LOAD_FAIL:
            return state.set("loading", false);


        // CompanyDetails & CompanySettings save

        case COMPANY_DETAILS_SAVE:
        case COMPANY_SETTINGS_SAVE:
            return state.set("loading", true);

        case COMPANY_DETAILS_SAVE_SUCCESS:

        case COMPANY_DETAILS_SAVE_FAIL:
        case COMPANY_SETTINGS_SAVE_FAIL:
            return state.set("loading", false);

        case COMPANY_SETTINGS_SAVE_SUCCESS:
            return state.set("loading", false)
                .set("loading", false)
                .setIn(["company_preferences", "country"], action.response.country)
                .setIn(["company_preferences", "currency"], action.response.currency)
                .setIn(["company_preferences", "timezone"], action.response.timezone)
                .setIn(["company_preferences", "language"], action.response.language)
                .setIn(["company_preferences", "privacy_policy"], action.response.privacy_link)
                .setIn(["company_preferences", "terms_conditions"], action.response.terms_link)

        // Tax

        case ALL_TAX_LOAD:
        case ALL_RESTORANTS_LOAD:
        case TAX_LOAD:
        case TAX_NEW_CREATE:
        case TAX_DELETE:
            return state.set("loading", true);

        case TAX_LOAD_SUCCESS:
            return state
                .set("loading", false)
                .set("redirect", false)
                .setIn(["tax","name"], action.response.data.name)
                .setIn(["tax","rate"], action.response.data.rate)
                .setIn(["tax","is_included"], action.response.data.is_included)
                .setIn(["tax","is_enable"], action.response.data.is_enable)
                .setIn(["tax","all_future_locations"], action.response.data.all_future_locations)
                .setIn(["tax","is_all_restaurants"], action.response.data.is_all_restaurants)
                .setIn(["tax","restaurants"], action.response.data.restaurants_list)

        case ALL_TAX_LOAD_SUCCESS:
            return state
                .set("loading", false)
                .set("redirect", false)
                .set("tax_list", action.response.data)

        case TAX_NEW_CREATE_SUCCESS:
        case TAX_DELETE_SUCCESS:
            return state
                .set("loading", false)
                .set("redirect", true)

        case TAX_FIELD_CLEAR:
            return state
            .setIn(["tax","name"], "")
            .setIn(["tax","rate"], "")
            .setIn(["tax","is_included"], false)
            .setIn(["tax","is_enable"], false)
            .setIn(["tax","all_future_locations"], false)
            .setIn(["tax","is_all_restaurants"], false)
            .setIn(["tax","restaurants"], [])

        case  ALL_RESTORANTS_LOAD_SUCCESS:
            return state
            .set("loading", false)
            .set("all_restaurants_list", action.response.data)

        case ALL_TAX_LOAD_FAIL:
        case ALL_RESTORANTS_LOAD_FAIL:
        case TAX_DELETE_FAIL:
        case TAX_LOAD_FAIL:
        case TAX_NEW_CREATE_FAIL:
            return state.set("loading", false);

        // PASS

        case PASSWORD_UPDATE:
            return state.set("loading", true);

        case PASSWORD_UPDATE_SUCCESS:
        case PASSWORD_UPDATE_FAIL:
            return state
                .set("loading", false)

        // Payment

        case DEFAULT_PAYMENT_LOAD:
        case CHANGE_DEFAULT_PAYMENT_SYSTEM_SAVE:
        case STRIPE_SYSTEM_DEAUTHORIZE:
        case YOOKASA_SYSTEM_DEAUTHORIZE:
        case AMERIABANK_ACCOUNT_SAVE:
        case AMERIABANK_ACCOUNT_DELETE:
            return state.set("loading", true);

        case DEFAULT_PAYMENT_LOAD_SUCCESS:
            return state
                .set("loading", false)
                .setIn(["payments","paymentProviders"], action.response.data.paymentProviders)
                .setIn(["payments","defaultProvider"], action.response.data.defaultProvider)
                .setIn(["payments","stripeAccounts"], action.response.data.stripeAccounts)
                .setIn(["payments","stripeOauthLink"], action.response.data.stripeOauthLink)
                .setIn(["payments","yookassaAccounts"], action.response.data.yookassaAccounts)
                .setIn(["payments","yookassaOauthLink"], action.response.data.yookassaOauthLink)
                .setIn(["payments","ameriabankAccount"], action.response.data.ameriabankAccount)

        case DEFAULT_PAYMENT_LOAD_FAIL:
        case CHANGE_DEFAULT_PAYMENT_SYSTEM_SAVE_SUCCESS:
        case CHANGE_DEFAULT_PAYMENT_SYSTEM_SAVE_FAIL:
        case STRIPE_SYSTEM_DEAUTHORIZE_FAIL:
        case YOOKASA_SYSTEM_DEAUTHORIZE_FAIL:
        case AMERIABANK_ACCOUNT_SAVE_FAIL:
        case AMERIABANK_ACCOUNT_DELETE_FAIL:
            return state.set("loading", false)

        case YOOKASA_SYSTEM_DEAUTHORIZE_SUCCESS:
        case STRIPE_SYSTEM_DEAUTHORIZE_SUCCESS:
        case AMERIABANK_ACCOUNT_DELETE_SUCCESS:
        case AMERIABANK_ACCOUNT_SAVE_SUCCESS:
            return state
                .set("loading", false)

        // User Profile

        case USER_PROFILE_LOAD:
        case USER_PROFILE_UPDATE:
            return state.set("loading", true);

        case USER_PROFILE_LOAD_SUCCESS:
            let two_factor
            if (Object.keys(action.response.data.two_fa).length === 0) {
                two_factor = false
            } else {two_factor = true}

            return state
            .set("loading", false)
            .set("redirect", false)
            .setIn(["user_profile","name"], action.response.data.name)
            .setIn(["user_profile","email"], action.response.data.email)
            .setIn(["user_profile","browser_sessions_list"], action.response.data.sessions)
            .setIn(["user_profile","two_factor_authentication"], action.response.data.two_fa)
            .setIn(["user_profile","is_two_factor_enabled"], two_factor)

        case USER_PROFILE_LOAD_FAIL:
        case USER_PROFILE_UPDATE_SUCCESS:
            return state
                .set("loading", false)
                .set("redirect", true)

        case USER_PROFILE_UPDATE_FAIL:
            return state.set("loading", false)

        // LogoutSession

        case LOGOUT_SESSIONS:
        return state.set("loading", true);

        case LOGOUT_SESSIONS_SUCCESS:
            return state
                .set("loading", false)
                .set("redirect", true)

        case LOGOUT_SESSIONS_FAIL:
            return state.set("loading", false)

        // TWO FACTOR

        case TWO_FACTOR_AUTH_CONFIRM_PASSWORD:
        case REGENERATE_CODE:
            return state.set("loading", true);

        case TWO_FACTOR_AUTH_CONFIRM_PASSWORD_SUCCESS:
        case REGENERATE_CODE_SUCCESS:
            return state
                .set("loading", false)
                .set("redirect", true)

        case TWO_FACTOR_AUTH_CONFIRM_PASSWORD_FAIL:
        case REGENERATE_CODE_FAIL:
            return state.set("loading", false)

        // DELETE ACCOUNT

        case DELETE_ACCOUNT:
            return state.set("loading", true);

        case DELETE_ACCOUNT_SUCCESS:
        case DELETE_ACCOUNT_FAIL:
            return state
                .set("loading", false)

        default:
            return state;
    }
};
